<template>
  <div class="animated fadeIn">
    <div class="page-card-margin row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.information_analysis}}</strong>
          </div>
          <div class="card-block">
            <div class="form-group row">
              <div class="col-md-4">
                <label>{{web_texts.select_device}}</label>
                <select id="select-01" name="select-01" class="form-control" v-model="selected_device">
                  <option value="0" disabled>{{web_texts.select_device}}</option>
                  <option :value="device" v-for="device in devices" v-if="device.name!=='Irrimation' && device.type!=='CVMNET4' && device.type!=='LM4A'">{{device.name}}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label>{{web_texts.date_range}}</label>
                  <div class="input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12">
                    <span class="add-on input-group-addon"><i class="glyphicon glyphicon-calendar fa fa-calendar"></i></span>
                    <input type="text" name="daterange" id="daterange" class="form-control input-lg"/>
                  </div>
              </div>
              <div class="col-md-4">
                <label>{{web_texts.select_var}}</label>
                <select id="select-02" name="select-02" class="form-control" v-model="var_type">
                  <option value="0" disabled>{{web_texts.select_var}}</option>
                  <option value="1" v-if="system.id!==20">{{web_texts.tension}}</option>
                  <option value="2" v-if="system.id!==20">{{web_texts.intensity}}</option>
                  <option value="3" v-if="system.id!==20">{{web_texts.cos_phi}}</option>
                  <option value="4" v-if="system.id!==20">{{web_texts.power_factor}}</option>
                  <option value="5">{{web_texts.active_energy}}</option>
                  <option value="6">{{web_texts.reactive_energy}}</option>
                  <option value="7" v-if="system.id!==20">{{web_texts.max_demand}}</option>
                  <option value="8">{{web_texts.active_power}}</option>
                  <option value="9" v-if="system.id!==20">{{web_texts.harmonic_intensity}}</option>
                  <option value="10" v-if="system.id!==20">{{web_texts.harmonic_tension}}</option>
                  <option value="11" v-if="system.id!==20">{{'MAX. '+web_texts.tension}}</option>
                  <option value="12" v-if="system.id!==20">{{'MAX. '+web_texts.intensity}}</option>
                  <option value="13" v-if="system.id!==20">{{'MAX. '+web_texts.cos_phi}}</option>
                  <option value="14" v-if="system.id!==20">{{'MIN. '+web_texts.tension}}</option>
                  <option value="15" v-if="system.id!==20">{{'MIN. '+web_texts.intensity}}</option>
                  <option value="16" v-if="system.id!==20">{{'MIN. '+web_texts.cos_phi}}</option>
                </select>
              </div>
            </div>
            <div class="row" style="margin-top: -20px">
              <div class="col-lg-10">
                <hr>
                <button class="btn btn-primary btn-sm" @click="selectTableOrGraphAndBuildRequest('graph')"><i
                  class="fa fa-line-chart"></i> {{web_texts.graphic}}
                </button>
                <button class="btn btn-primary btn-sm" @click="selectTableOrGraphAndBuildRequest('table')"><i
                  class="fa fa-table"></i> {{web_texts.table}}
                </button>
              </div>
              <div class="col-lg-2 right">
                <hr>
                <button class="btn btn-primary btn-sm" @click="selectTableOrGraphAndBuildRequest('csv')"><i
                  class="fa fa-download"></i> CSV
                </button>
                <button class="btn btn-primary btn-sm" @click="selectTableOrGraphAndBuildRequest('xml')"><i
                  class="fa fa-download"></i> XML
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GeneralSpinner v-if="to_show==='spinner'"></GeneralSpinner>
    <div class="row" v-else-if="to_show==='table'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.info_to_export}}</strong>
          </div>
          <div class="card-block">
            <vue-good-table :columns="columns" :rows="table_data_power" :paginate="true" :perPage="5">
              <template slot="table-row" scope="props">
                <td>{{props.row.dateTime}}</td>
                <td v-if="multiple_values" v-for="lectures in props.row.field">{{Math.round(lectures.value*100)/100 +' '+ units_graphs}}</td>
                <td v-if="!multiple_values">{{Math.round(props.row.field.value*100)/100 +' '+ units_graphs}}</td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="to_show==='graph'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.maximeter_historical}}</strong>
          </div>
          <div class="card-block">
            <div id="chartContainer" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import trans_cat from '../translates/cat/ExportData';
  import trans_es from '../translates/es/ExportData';
  import constants from '../constants';
  import middleware from '../utilities/middlewares';
  import dataTransforms from '../utilities/data_transformers';
  import dates_intervals from '../utilities/dates_intervals'
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: '',
    data() {
      return {
        web_texts: { "information_analysis": "Anàlisi d'informació", "select_device": "Slececciona Dispositiu", "date_range": "Rang de dates", "select_var": "Selecciona Variable", "tension": "Tensió", "intensity": "Intensitat", "cos_phi": "Cosinus Phi", "power_factor": "Factor Pot.", "active_energy": "Energia Act.", "reactive_energy": "Energia React.", "max_demand": "Max. Demanda", "active_power": "Potencia Act.", "harmonic_intensity": "Armonic Int.", "harmonic_tension": "Armonic Ten.", "graphic": "Gràfic", "table": "Taula", "info_to_export": "Informació a Exportar", "maximeter_historical": "Històric Maxímetre" },
        devices: '',
        device: '',
        check_boxes: [],
        checked: '',
        table_data_power: [],
        months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
        captions: {'ok_button': 'Seleccionar'},
        shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
        columns: [],
        multiple_values: true,
        to_show:'',
        var_type: 0,
        units_graphs: '',
        selected_device: ''
      }
    },
    components:{
      GeneralSpinner
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["export_data","export_data"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.system = JSON.parse(localStorage.getItem('system'));
      this.getDevices();
    },
    mounted(){
      // inicialitzem daterangepicker
      this.initializeDateRangePicker();
    },
    methods: {
      // Funcio que demana el dispositiu i busca les dades per a crear el checkbox
      getDevices() {
        axios.post(constants.ROOT_URL + '/api/v1/get_devices', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.devices = response.data;
        }, (response) => {
          console.log(response.data);
        });
      },
      selectTableOrGraphAndBuildRequest(value){
        var req_par, to_show_internal;

        switch (parseInt(this.var_type)) {
          case 0:
            req_par = [];
            to_show_internal = [];
            break;
          case 1:
            req_par = [[this.selected_device.id.toString() , 'VI1', 'VI2', 'VI3']];
            to_show_internal = [['L1 V', 'L2 V', 'L3 V']];
            this.units_graphs='V';
            break;
          case 2:
            req_par = [[this.selected_device.id.toString(), 'AI1', 'AI2', 'AI3']];
            to_show_internal = [['L1 A', 'L2 A', 'L3 A']];
            this.units_graphs='A';
            break;
          case 3:
            req_par = [[this.selected_device.id.toString(), 'COSI', 'COSI1', 'COSI2', 'COSI3']];
            to_show_internal = [['||| φ', 'L1 φ', 'L2 φ', 'L3 φ']];
            this.units_graphs='φ';
            break;
          case 4:
            req_par = [[this.selected_device.id.toString(), 'PFI']];
            to_show_internal = [['||| FP']];
            this.units_graphs='φ';
            break;
          case 5:
            req_par = [[this.selected_device.id.toString(), 'AE']];
            to_show_internal = [['||| kWh']];
            this.units_graphs='kWh';
            break;
          case 6:
            req_par = [[this.selected_device.id.toString(), 'IE']];
            to_show_internal = [['||| kWh']];
            this.units_graphs='kWh';
            break;
          case 7:
            req_par = [[this.selected_device.id.toString(), 'MDAPI', 'MDI']];
            to_show_internal = [['||| kW']];
            this.units_graphs='kW';
            break;
          case 8:
            req_par = [[this.selected_device.id.toString(), 'API', 'API1', 'API2', 'API3']];
            to_show_internal = [['||| kW', 'L1 kW', 'L2 kW', 'L3 kW']];
            this.units_graphs='kW';
            break;
          case 9:
            req_par = [[this.selected_device.id.toString(), 'ARM3A1', 'ARM3A2', 'ARM3A3', 'ARM5A1', 'ARM5A2', 'ARM5A3', 'ARM7A1', 'ARM7A2', 'ARM7A3']];
            to_show_internal = [['L1 %Arm.I 3', 'L2 %Arm.I 3', 'L3 %Arm.I 3', 'L1 %Arm.I 5', 'L2 %Arm.I 5', 'L3 %Arm.I 5', 'L1 %Arm.I 7', 'L2 %Arm.I 7', 'L3 %Arm.I 7']];
            this.units_graphs='%';
            break;
          case 10:
            req_par = [[this.selected_device.id.toString(), 'ARM3V1', 'ARM3V2', 'ARM3V3', 'ARM5V1', 'ARM5V2', 'ARM5V3', 'ARM7V1', 'ARM7V2', 'ARM7V3']];
            to_show_internal = [['L1 %Arm.T 3', 'L2 %Arm.T 3', 'L3 %Arm.T 3', 'L1 %Arm.T 5', 'L2 %Arm.T 5', 'L3 %Arm.T 5', 'L1 %Arm.T 7', 'L2 %Arm.T 7', 'L3 %Arm.T 7']];
            this.units_graphs='%';
            break;
          case 11:
            req_par = [[this.selected_device.id.toString() , 'VMX1', 'VMX2', 'VMX3']];
            to_show_internal = [['L1 V', 'L2 V', 'L3 V']];
            this.units_graphs='V';
            break;
          case 12:
            req_par = [[this.selected_device.id.toString(), 'AMX1', 'AMX2', 'AMX3']];
            to_show_internal = [['L1 A', 'L2 A', 'L3 A']];
            this.units_graphs='A';
            break;
          case 13:
            req_par = [[this.selected_device.id.toString(), 'COSMX', 'COSMX1', 'COSMX2', 'COSMX3']];
            to_show_internal = [['||| φ', 'L1 φ', 'L2 φ', 'L3 φ']];
            this.units_graphs='φ';
            break;
          case 14:
            req_par = [[this.selected_device.id.toString() , 'VMN1', 'VMN2', 'VMN3']];
            to_show_internal = [['L1 V', 'L2 V', 'L3 V']];
            this.units_graphs='V';
            break;
          case 15:
            req_par = [[this.selected_device.id.toString(), 'AMN1', 'AMN2', 'AMN3']];
            to_show_internal = [['L1 A', 'L2 A', 'L3 A']];
            this.units_graphs='A';
            break;
          case 16:
            req_par = [[this.selected_device.id.toString(), 'COSMN', 'COSMN1', 'COSMN2', 'COSMN3']];
            to_show_internal = [['||| φ', 'L1 φ', 'L2 φ', 'L3 φ']];
            this.units_graphs='φ';
            break;
        }

        if(value==='graph'){
          this.getGraphArrayPower(req_par, to_show_internal);
        }else if(value==='table'){
          this.getTableArrayPower(req_par, to_show_internal);
        }else if(value==='csv'){
          this.getDataExport(req_par,'csv');
        }else if(value==='xml'){
          this.getDataExport(req_par,'xml');
        }
      },
      // Funcio que agafa els valors per a imprimir la taula
      getTableArrayPower(req_par, to_show_internal) {
        // La funcio headerTable es la que printa els tituls a la taula
        this.headerTable(req_par, to_show_internal[0]);
        // agafem els valors per a implimir la taula
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify(req_par),
          date_range: document.getElementById('daterange').value
        }).then((response) => {
          this.to_show='table';
          this.formatTableDate(response.data);
        }, (response) => {
          console.log(response.data);
        });
      },
      // funcio printa els tituls a la taula
      headerTable(req_par, to_show_internal) {
        if (to_show_internal.length > 1) {
          this.multiple_values = true;
        } else {
          this.multiple_values = false;
        }

        var header_make = '[{"label": "Data i hora"}';
        for (var i = 0; i < to_show_internal.length; i++) {
          header_make += ', {"label": "' + to_show_internal[i] + '"}';
        }
        header_make += ']';
        this.columns = JSON.parse(header_make);
      },
      getDataExport(req_par, format) {
        axios.post(constants.ROOT_URL + '/api/v1/stored_value_to_'+format, {
          system_id: this.system.id,
          vars: JSON.stringify(req_par),
          client_device: 'd',
          date_range: document.getElementById('daterange').value
        }).then((response) => {
          console.log(response.data);
          // for(var i=0; i<response.data.length;i++){
          //   response.data[i].dateTime = dates_intervals.correctDateTimeAPI(dates_intervals.transformDateResponse(response.data[i].dateTime));
          // }

          var file = new File([response.data], "Stored_Values."+format, {type: "text/plain;charset=utf-8"});
          FileSaver.saveAs(file);
        }, (response) => {
          console.log(response.data);
        });
      },
      // Funcio que agafa els valors per a mostrar al graf
      getGraphArrayPower(req_par, to_show_internal) {
        console.log(req_par);
        // agafem els valors per a implimir la taula
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          vars: JSON.stringify(req_par),
          client_device: 'd',
          date_range: document.getElementById('daterange').value
        }).then((response) => {
          var data_resp=response.data;
          var out=this;
          this.to_show='graph';
          var arr_before_req=req_par;

          setTimeout(function () {
            out.printGraph(dataTransforms.lineDataTransformCanvasJS(data_resp, "line", to_show_internal[0]));
          },25);

        }, (response) => {
          console.log(response.data);
        });
      },
      // Funcio que imprimeix el grafic
      printGraph(data){
        //Better to construct options first and then pass it as a parameter
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX:{
            valueFormatString: "DD/MM HH:mm"
          },
          axisY: {
            suffix: this.units_graphs
          },
          data: data  // random data
        };

        $("#chartContainer").CanvasJSChart(options);
      },
      // Funcio que imprimeix la taula
      formatTableDate(array_date){
        for(var i=0; i<array_date.length;i++){
          array_date[i].dateTime = dates_intervals.correctDateTimeAPI(dates_intervals.transformDateResponse(array_date[i].dateTime));
        }
        this.table_data_power = array_date;
      },
      // Funcio per a que funcione el datepicker
      initializeDateRangePicker(){
        $(function() {
          var date = new Date();
          var month = date.getMonth();
          var year = date.getFullYear();
          $('input[name="daterange"]').daterangepicker({
            "locale": {
              "format": "DD/MM/YYYY",
              "separator": " - ",
              "applyLabel": "Acceptar",
              "cancelLabel": "Cancel·lar",
              "fromLabel": "Des de",
              "toLabel": "Fins",
              "customRangeLabel": "Custom",
              "weekLabel": "W",
              "daysOfWeek": [
                "dg",
                "dl",
                "dt",
                "dc",
                "dj",
                "dv",
                "ds"
              ],
              "monthNames": [
                "Gener",
                "Febrer",
                "Març",
                "Abril",
                "Maig",
                "Juny",
                "Juliol ",
                "Agost ",
                "Setembre",
                "Octubre",
                "Novembre",
                "Desembre"
              ],
              "firstDay": 1
            },
            "startDate": "1/"+(month+1)+"/"+year,
            "endDate": "28/"+(month+1)+"/"+year
          })
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// ExportData.vue?1420b2d2